require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./travailler-lepfl-0-5.json") })
        }
      }, "path---travailler-lepfl-0-5");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---travailler-lepfl-0-5!./.cache/json/travailler-lepfl-0-5.json
// module id = 595
// module chunks = 231608221292675